import { SplitService } from "../services/helpers/split.service";

export function initializeSplit(splitService: SplitService): () => Promise<void> {
    return () => {
        const userKey = 'default';
        return splitService.initialize(userKey).catch(() => undefined);
    };
}
